import { FollowUrlParamMismatchException } from "@/services/user/follow/followExceptions";
import { FollowDirection } from "@/services/user/follow/followTypes";

/** Reads a follow direction back from a URL segment. Keep in sync with the `:direction(...)` route mask. */
export const parseFollowDirection = (value: unknown): FollowDirection => {
  if (value === FollowDirection.Following) {
    return FollowDirection.Following;
  }
  if (value === FollowDirection.Followers) {
    return FollowDirection.Followers;
  }
  throw new FollowUrlParamMismatchException("Unrecognized follow param value");
};
